// import { deleteTransactionApi, getAccountingTransaction, getExpense } from "_services";
// import {
//   CommonDateRange,
//   CommonInput,
//   CustomPagination,
//   CustomSelect,
// } from "components";
// import { constant } from "constants/constant";
// import { utils } from "helper";
// import moment from "moment";
// import React, { useEffect, useRef, useState } from "react";
// import { FaEnvelope, FaRegEdit } from "react-icons/fa";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import StorageService from "utils/StorageServices/StorageServices";
// import Tab from "components/common/Tab";
// import { IoChevronBack, IoChevronForward } from "react-icons/io5";
// import { FaRegTrashCan } from "react-icons/fa6";
// import { FiEdit } from "react-icons/fi";
// import { AiOutlineEye } from "react-icons/ai";
// import { BsThreeDotsVertical } from "react-icons/bs";
// import toast from "react-hot-toast";
// import { ConfirmModalFor, EditAccountingModal, PaymentVoucher } from "modals";
// import { Images } from "constants";
// import { API, AppConfig } from "lib";
// import { MdEdit } from "react-icons/md";

// const TransactionsDetails = () => {
//   const [activeTab, setActiveTab] = useState(1);
//   const [openEditModal, setOpenEditModal] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   let isToken = localStorage.getItem("token");
//   const { data } = location.state || {};

//   // Separate loading states for each action
//   const [initialLoading, setInitialLoading] = useState(false);
//   const [pdfLoading, setPdfLoading] = useState(false);
//   const [excelLoading, setExcelLoading] = useState(false);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(false);

//   const [transactionList, setTransactionList] = useState([]);
//   const [expenseList, setExpenseList] = useState([]);
//   const [selectedRange, setSelectedRange] = useState({
//     startDate: moment().startOf('month'),
//     endDate: moment().endOf('month'),
//   });

//   const [accountDetails, setAccountDetails] = useState({})

//   const isFirstRun = useRef(true);
//   const tableContainerRef = useRef(null);
//   const isFetchingRef = useRef(false);
//   const hasMoreRef = useRef(true);
//   const totalLoadedRef = useRef(0);
//   const offsetRef = useRef(1);
//   const [isSearch, setIsSearch] = useState('')
//   const [totalItems, setTotalItems] = useState(0);
//   const [filter, setFilter] = useState({
//     limit: 30,
//     // offset: 1,
//     search: '',
//   });

//   const [confirmModalShow, setConfirmModalShow] = useState(false);
//   const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);

//   const columns = [
//     { header: "", accessor: "serial" },
//     { header: "Date", accessor: "tADate" },
//     { header: "Voucher No", accessor: "voucher_no" },
//     { header: "Transaction Type", accessor: "transactionType" },
//     { header: "Expense Category", accessor: "category" },
//     { header: "Description", accessor: "description" },
//     { header: "Receipt (₹)", accessor: "debit_amount" },
//     { header: "Payment (₹)", accessor: "credit_amount" },
//     { header: "Running Balance (₹)", accessor: "running_balance" },
//   ];

//   const getCategoriesNames = (item) => {
//     if (item?.voucher_id?.category_type == 1) {
//       return <>{item?.voucher_id?.categories[0]?.category?.name}</>;
//     }
//     if (item?.voucher_id?.category_type == 2) {
//       return <>{item?.voucher_id?.category_name}</>;
//     }
//   };

//   const accessorList = (data, startingBalance = 0) => {
//     let runing_balance = startingBalance;
//     const listArray = data?.map((item, i) => {
//       runing_balance += item?.entries?.debit_amount - item?.entries?.credit_amount;
//       return {
//         ...item,
//         serial: (
//           <>
//             {(i != 0 || item?.type_name != "Opening Balance") && <React.Fragment>
//               <div className="signDropdown">
//                 <button className="dropbtn11">
//                   <BsThreeDotsVertical />
//                 </button>
//                 <div className="dropdownContent">
//                   <div onClick={(e) => {
//                     e.stopPropagation();
//                     handleDelteSubmit(item);
//                   }} className="_avPointer">
//                     <span className="_samAnchor">
//                       <span className="deleteIcon_avt">
//                         <FaRegTrashCan color="red" />
//                       </span>
//                       Delete
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </React.Fragment>}
//           </>
//         ),
//         tADate: (
//           <>
//             <div className="_dateTbs">
//               {item?.date ? utils.formatDateMonth(item?.date) : "-"}
//             </div>
//           </>
//         ),
//         description: (
//           <>
//             <div className="fBold">{item?.trip?.trip_number ? item?.trip?.trip_number : ""} </div>
//             <div>
//               {item?.trip?.route_name || item?.description ? (
//                 <>
//                   {item?.trip?.route_name || ""}
//                   {item?.trip?.route_name && item?.description ? " | " : ""}
//                   {item?.description || ""}
//                 </>
//               ) : null}
//             </div>
//           </>
//         ),
//         debit_amount: item?.entries?.debit_amount ? `${(item?.entries?.debit_amount).toFixed(2)}` : "-",
//         credit_amount: item?.entries?.credit_amount ? `${(item?.entries?.credit_amount).toFixed(2)}` : "-",
//         running_balance: runing_balance ? `${(runing_balance).toFixed(2)}` : 0,
//         accontName: item?.entries?.account?.name ? item?.entries?.account?.name : "",
//         transactionType: (
//           <>
//             <div>
//               {item?.sub_type_name ? item?.sub_type_name : item?.type_name}
//             </div>
//           </>
//         ),
//         category: (
//           <>
//             <div>
//               {getCategoriesNames(item)}
//             </div>
//           </>
//         ),
//         accountName: (
//           <>
//             <div>
//               {item?.account_name == "Opening Balance" ? (
//                 <h6>{item?.account_name}</h6>
//               ) : (
//                 item?.account_name
//               )}
//             </div>
//           </>
//         ),
//       };
//     });
//     return listArray;
//   };

//   // Initial load on component mount
//   useEffect(() => {
//     getAccountTransactionListHandler(data, true);
//   }, []);

//   useEffect(() => {
//     if (isFirstRun.current) {
//       isFirstRun.current = false;
//       return;
//     }
//     // Reset for new search/filter
//     setTransactionList([]);
//     offsetRef.current = 1;  // R
//     hasMoreRef.current = true;
//     totalLoadedRef.current = 0;
//     getAccountTransactionListHandler(data, true);
//   }, [selectedRange, activeTab, filter.search]);

//   const handleApply = (newRange) => {
//     setSelectedRange(newRange);
//   };

//   const getAccountTransactionListHandler = async (data, isReset = false) => {
//     if (!data) {
//       console.error('No data provided:', data);
//       return;
//     }

//     if (isFetchingRef.current) {
//       console.log('Already fetching, skipping...');
//       return;
//     }

//     if (!hasMoreRef.current && !isReset) {
//       console.log('No more data, skipping...');
//       return;
//     }

//     try {
//       isFetchingRef.current = true;
//       console.log('Setting isFetchingRef to TRUE');

//       if (!isReset) {
//         setLoadingMore(true);
//       } else {
//         setInitialLoading(true);
//       }

//       const currentOffset = isReset ? 1 : offsetRef.current;

//       const res = await getAccountingTransaction({
//         limit: filter.limit,
//         offset: currentOffset,
//         search: filter.search,
//         company_id: StorageService?.getCompanyId(),
//         account_id: data?.account_id,
//         start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
//         end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
//         approval_status: activeTab,
//       });

//       if (res?.responseCode === 200) {
//         const { list, ...resData } = res?.data;


//         let newList = list || [];

//         if (currentOffset > 1 && newList.length > 0) {
//           console.log('⚠️ Skipping first item for offset:', currentOffset);
//           newList = newList.slice(1); // Remove first item
//         }

//         // ✅ HANDLE N+1 PAGINATION (API returns 31 when limit is 30)
//         const actualReturnedCount = (list || []).length;
//         let hasMore = false;

//         if (actualReturnedCount > filter.limit) {
//           // API returned more than limit (e.g., 31 when limit is 30)
//           // This means there's more data
//           hasMore = true;
//           // Remove the extra item (we'll fetch it in next call)
//           newList = newList.slice(0, filter.limit);

//         } else {
//           hasMore = false;
//         }

//         // Handle filtering for activeTab == 2 (AFTER trimming)
//         if (activeTab == 2 && newList.length > 0 && currentOffset === 1) {
//           console.log('⚠️ Filtering first item for activeTab=2');
//           newList = newList.filter((_, index) => index !== 0);
//         }

//         setAccountDetails(res?.data?.account_detail);
//         setTotalItems(res?.data?.total_record);

//         // Update total loaded count
//         if (isReset) {
//           totalLoadedRef.current = newList.length;
//         } else {
//           totalLoadedRef.current += newList.length;
//         }

//         hasMoreRef.current = hasMore;

//         if (isReset) {
//           // Reset scenario - replace all data
//           setTransactionList({ ...resData, list: newList });
//           console.log('Reset - New list length:', newList.length);
//         } else {
//           // Append scenario - add new data to existing
//           setTransactionList(prev => {
//             const updatedList = [...(prev.list || []), ...newList];
//             console.log('Append - Previous length:', prev.list?.length || 0, 'New items:', newList.length, 'Total:', updatedList.length);
//             return {
//               ...resData,
//               list: updatedList
//             };
//           });
//         }

//         // Update offset for next fetch
//         if (hasMore) {
//           const nextOffset = currentOffset + 1;
//           offsetRef.current = nextOffset;  // Upd
//           console.log('✅ Next offset will be:', nextOffset);
//         } else {
//           console.log('⛔ No more data - offset stays at:', currentOffset);
//         }
//       } else {
//         console.log('❌ API error, navigating back');
//         navigate('/accounting/transactions');
//       }
//     } catch (error) {
//       console.error('Exception in API call:', error);
//       toast.error('Error');
//     } finally {
//       isFetchingRef.current = false;
//       console.log('Setting isFetchingRef to FALSE');
//       setInitialLoading(false);
//       setLoadingMore(false);
//     }
//   };

//   // Infinite scroll handler with proper dependencies
//   const handleScroll = React.useCallback(() => {
//     // console.log("dgfdgfgh",tableContainerRef.current)
//     if (!tableContainerRef.current) return;

//     const { scrollTop, scrollHeight, clientHeight } = tableContainerRef.current;

//     // Check if scrolled to bottom (with 50px threshold)
//     if (scrollHeight - scrollTop <= clientHeight) {
//       if (!isFetchingRef.current && hasMoreRef.current && data) {
//         getAccountTransactionListHandler(data, false);
//       }
//     }
//   }, [data, activeTab, selectedRange, filter.search]);

//   useEffect(() => {
//     const container = tableContainerRef.current;
//     if (container) {
//       container.addEventListener('scroll', handleScroll);
//       return () => container.removeEventListener('scroll', handleScroll);
//     }
//   }, [handleScroll]);

//   const tabProps = {
//     tabList: constant.transactionsDetailsTabs,
//     callBackTab: (e) => {
//       setActiveTab(e);
//     },
//     activeTab: activeTab,
//   };

//   const getNumberSign = (number) => {
//     const parsedNumber = parseFloat(number);
//     if (isNaN(parsedNumber)) return 0;
//     return parsedNumber < 0 ? `${number}` : number;
//   };

//   const handleDelteSubmit = (i) => {
//     setConfirmModalShow(i);
//   };

//   const handleDelete = async () => {
//     const payload = {
//       company_id: StorageService?.getCompanyId(),
//       transaction_id: confirmModalShow?._id || paymentVoucherOpen?._id
//     }
//     try {
//       setDeleteLoading(true)
//       const res = await deleteTransactionApi(payload)
//       if (res?.responseCode == 200) {
//         toast.success(res?.responseMessage)
//         setConfirmModalShow(false);
//         setPaymentVoucherOpen(false)
//         setTransactionList([]);
//         offsetRef.current = 1;
//         hasMoreRef.current = true;
//         totalLoadedRef.current = 0;
//         getAccountTransactionListHandler(data, true);
//       } else {
//         toast.error(res?.responseMessage)
//       }
//     } catch (error) {
//       toast.error(error?.message)
//     } finally {
//       setDeleteLoading(false)
//     }
//   };

//   let confirmModalProps = {
//     show: confirmModalShow,
//     closeModal: (e) => {
//       setConfirmModalShow(false);
//     },
//     title: "Confirm",
//     submitTitle: "Delete",
//     onSubmit: handleDelete,
//     confirmModal: "confirmModal",
//     icon: Images.DELETEICON.default,
//     isLoadding: deleteLoading,
//     disabled: deleteLoading
//   };

//   useEffect(() => {
//     const isClear = setTimeout(() => {
//       setFilter((s) => ({ ...s, search: isSearch }))
//       offsetRef.current = 1;
//     }, 500)

//     return () => clearTimeout(isClear)
//   }, [isSearch])

//   const callbackPreview = (e, row) => {
//     setPaymentVoucherOpen(row)
//   }

//   const paymentVoucherProps = {
//     paymentVoucherOpen: paymentVoucherOpen,
//     closeModal: () => setPaymentVoucherOpen(false),
//     voucherId: paymentVoucherOpen?.voucher_id?._id,
//     oprnDeleteModal: setConfirmModalShow
//   }

//   const transactionDownloadPdf = async () => {
//     setPdfLoading(true)
//     try {
//       const payload = {
//         search: isSearch,
//         company_id: StorageService.getCompanyId(),
//         account_id: data?.account_id,
//         start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
//         end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
//         approval_status: activeTab,
//         is_web: true
//       }
//       const response = await fetch(`${AppConfig.api_baseurl}${API.TRANSACTIONS_REPORT}`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Token': `${isToken}`,
//         },
//         body: JSON.stringify(payload)
//       });

//       if (!response.ok) {
//         const errorBody = await response.json().catch(() => ({}));
//         if (errorBody?.responseMessage) {
//           toast.error(errorBody?.responseMessage);
//         }
//         throw new Error(`Server Error (${errorBody?.responseMessage})`);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `${transactionList?.account_detail?.name}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setPdfLoading(false);
//     }
//   }

//   const exportHandle = async () => {
//     setExcelLoading(true);
//     try {
//       const payload = {
//         search: isSearch,
//         company_id: StorageService.getCompanyId(),
//         account_id: data?.account_id,
//         start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
//         end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
//         approval_status: activeTab,
//         is_web: true
//       };
//       const response = await fetch(
//         `${AppConfig.api_baseurl}${API.ACCOUNT_EXPORT_EXCEL}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Token: `${isToken}`,
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Network response was not ok");
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "account_transaction.xlsx";
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//     } catch (error) {
//       console.error(error);
//       toast.error('Export failed');
//     } finally {
//       setExcelLoading(false);
//     }
//   };

//   const callBack = () => {
//     setOpenEditModal(false)
//     offsetRef.current = 1;
//     hasMoreRef.current = true;
//     totalLoadedRef.current = 0;
//     getAccountTransactionListHandler(data, true);
//   }

//   let accountEditModalProps = {
//     isOpen: openEditModal,
//     closeModal: (e) => setOpenEditModal(false),
//     modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
//     footerPart: false,
//     approvalBtn: true,
//     approvalBtnTxt: 'Cancel',
//     modalTitle: "Edit Account",
//     submitTitle: "Save",
//     accountDetails: accountDetails,
//     callBack: callBack
//   }

//   return (
//     <>
//       <div className="_trnsBr_flex">
//         <div className="_leftBrch_filts">
//           <div className='branch_left' style={{ justifyContent: 'flex-start', marginBottom: '1px' }}>
//             <h6>{transactionList?.account_detail?.name ? transactionList?.account_detail?.name : 'Loading...'}</h6>

//             <button
//               className="anime-btn _addComm_btn __editPetyCash"
//               onClick={() => setOpenEditModal(true)}
//               disabled={!transactionList?.account_detail?.name || initialLoading}
//             >
//               Edit
//             </button>
//           </div>
//           <div className="_brchsBalance">
//             <span
//               className={`${transactionList?.available_balance >= 0 ? "_plus₹" : "_minus₹"
//                 }`}
//             >
//               {`Balance ₹ ${getNumberSign(
//                 transactionList?.available_balance
//               )} `}{" "}
//             </span>
//             <span
//               className={`${transactionList?.account_detail?.under_approval_balance >= 0
//                 ? "_plus₹"
//                 : "_minus₹"
//                 }`}
//             >
//               {`Under Approval ₹ ${getNumberSign(
//                 transactionList?.account_detail?.under_approval_balance
//               )} `}{" "}
//             </span>
//           </div>
//         </div>

//         <div className="_rightBrch_filts">
//           <div>
//             <CommonInput
//               label="Search"
//               value={isSearch}
//               type="text"
//               placeholder="Search"
//               name="search"
//               onChange={(e) => setIsSearch(e.target.value)}
//             />
//           </div>
//           <div>
//             <CustomSelect
//               placeholder="Category"
//               label="Category"
//               options={expenseList}
//             />
//           </div>
//           <div>
//             <CommonDateRange
//               initialStartDate={selectedRange.startDate}
//               initialEndDate={selectedRange.endDate}
//               onApply={handleApply}
//             />
//           </div>
//           <a href="" className="_addComm_btn _envlBtn">
//             <FaEnvelope />
//           </a>
//           <button
//             className="_addComm_btn"
//             onClick={(e) => exportHandle(e)}
//             disabled={excelLoading || !transactionList?.account_detail?.name}
//           >
//             {excelLoading ? 'Exporting...' : 'Export'}
//           </button>
//           <button
//             className="_addComm_btn"
//             onClick={(e) => transactionDownloadPdf(e)}
//             disabled={pdfLoading || !transactionList?.account_detail?.name}
//           >
//             {pdfLoading ? 'Downloading...' : 'Download'}
//           </button>
//         </div>
//       </div>

//       <div className="addPr_flBx _altDetail">
//         <Tab {...tabProps} />
//         <div className="_transactionTable" ref={tableContainerRef} style={{ maxHeight: '600px', overflowY: 'auto' }}>
//           {initialLoading && transactionList?.list?.length === 0 ? (
//             <div style={{ textAlign: 'center', padding: '40px' }}>
//               <span>Loading transactions...</span>
//             </div>
//           ) : (
//             <CustomeTable
//               columns={columns}
//               data={accessorList(
//                 transactionList?.list?.length ? transactionList?.list : []
//               )}
//               callbackPreview={callbackPreview}
//             />
//           )}
//           {loadingMore && (
//             <div style={{ textAlign: 'center', padding: '20px' }}>
//               <span>Loading more...</span>
//             </div>
//           )}
//           {!hasMoreRef.current && transactionList?.list?.length > 0 && (
//             <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
//               <span>No more transactions</span>
//             </div>
//           )}
//         </div>
//       </div>

//       {openEditModal && <EditAccountingModal {...accountEditModalProps} />}

//       {confirmModalShow && (
//         <ConfirmModalFor {...confirmModalProps}>
//           <>
//             <p className="_confirmPrx">
//               {" "}
//               Are you sure you want to delete " {"Transaction"} "{" "}
//             </p>
//           </>
//         </ConfirmModalFor>
//       )}

//       {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
//     </>
//   );
// };

// export default TransactionsDetails;

// const CustomeTable = ({ columns, data, callbackPreview }) => {
//   return (
//     <table className="">
//       <thead>
//         <tr>
//           {columns.map((column, index) => (
//             <th key={index}>{column.header}</th>
//           ))}
//           <th></th>
//         </tr>
//       </thead>

//       <tbody>
//         {data?.map((row, rowIndex) => (
//           <tr key={rowIndex} onClick={(e) => rowIndex != 0 && callbackPreview(e, row)} style={{ cursor: 'pointer' }}>
//             {columns.map((column, colIndex) => (
//               <td key={colIndex}>{row[column.accessor]}</td>
//             ))}
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// };


import { deleteTransactionApi, getAccountingTransaction, getExpense } from "_services";
import {
  CommonDateRange,
  CommonInput,
  CustomPagination,
  CustomSelect,
} from "components";
import { constant } from "constants/constant";
import { utils } from "helper";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { FaEnvelope, FaRegEdit } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import Tab from "components/common/Tab";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import toast from "react-hot-toast";
import { ConfirmModalFor, EditAccountingModal, PaymentVoucher } from "modals";
import { Images } from "constants";
import { API, AppConfig } from "lib";
import { MdEdit } from "react-icons/md";

const TransactionsDetails = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [openEditModal, setOpenEditModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  let isToken = localStorage.getItem("token");
  const { data } = location.state || {};

  // Separate loading states for each action
  const [initialLoading, setInitialLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [transactionList, setTransactionList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [selectedRange, setSelectedRange] = useState({
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  });

  const [accountDetails, setAccountDetails] = useState({})

  const isFirstRun = useRef(true);
  const tableContainerRef = useRef(null);
  const loadingBarRef = useRef(null);
  const isLoadingRef = useRef(false);
  const hasMoreRef = useRef(true);
  const totalLoadedRef = useRef(0);
  const offsetRef = useRef(1);
  const [isSearch, setIsSearch] = useState('')
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 100,
    search: '',
  });

  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Date", accessor: "tADate" },
    { header: "Voucher No", accessor: "voucher_no" },
    { header: "Transaction Type", accessor: "transactionType" },
    { header: "Expense Category", accessor: "category" },
    { header: "Description", accessor: "description" },
    { header: "Receipt (₹)", accessor: "debit_amount" },
    { header: "Payment (₹)", accessor: "credit_amount" },
    { header: "Running Balance (₹)", accessor: "running_balance" },
  ];

  const getCategoriesNames = (item) => {
    if (item?.voucher_id?.category_type == 1) {
      return <>{item?.voucher_id?.categories[0]?.category?.name}</>;
    }
    if (item?.voucher_id?.category_type == 2) {
      return <>{item?.voucher_id?.category_name}</>;
    }
  };

  const accessorList = (data, startingBalance = 0) => {
    let runing_balance = startingBalance;
    const listArray = data?.map((item, i) => {
      runing_balance += item?.entries?.debit_amount - item?.entries?.credit_amount;
      return {
        ...item,
        serial: (
          <>
            {(i != 0 || item?.description != "Opening Balance") && <React.Fragment>
              <div className="signDropdown">
                <button className="dropbtn11">
                  <BsThreeDotsVertical />
                </button>
                <div className="dropdownContent">
                  <div onClick={(e) => {
                    e.stopPropagation();
                    handleDelteSubmit(item);
                  }} className="_avPointer">
                    <span className="_samAnchor">
                      <span className="deleteIcon_avt">
                        <FaRegTrashCan color="red" />
                      </span>
                      Delete
                    </span>
                  </div>
                </div>
              </div>
            </React.Fragment>}
          </>
        ),
        tADate: (
          <>
            <div className="_dateTbs">
              {item?.date ? utils.formatDateMonth(item?.date) : "-"}
            </div>
          </>
        ),
        description: (
          <>
            <div className="fBold">{item?.trip?.trip_number ? item?.trip?.trip_number : ""} </div>
            <div>
              {item?.trip?.route_name || item?.description ? (
                <>
                  {item?.trip?.route_name || ""}
                  {item?.trip?.route_name && item?.description ? " | " : ""}
                  {item?.description || ""}
                </>
              ) : null}
            </div>
          </>
        ),
        debit_amount: item?.entries?.debit_amount ? `${(item?.entries?.debit_amount).toFixed(2)}` : "-",
        credit_amount: item?.entries?.credit_amount ? `${(item?.entries?.credit_amount).toFixed(2)}` : "-",
        running_balance: runing_balance ? `${(runing_balance).toFixed(2)}` : 0,
        accontName: item?.entries?.account?.name ? item?.entries?.account?.name : "",
        transactionType: (
          <>
            <div>
              {item?.sub_type_name ? item?.sub_type_name : item?.type_name}
            </div>
          </>
        ),
        category: (
          <>
            <div>
              {getCategoriesNames(item)}
            </div>
          </>
        ),
        accountName: (
          <>
            <div>
              {item?.account_name == "Opening Balance" ? (
                <h6>{item?.account_name}</h6>
              ) : (
                item?.account_name
              )}
            </div>
          </>
        ),
      };
    });
    return listArray;
  };

  // Initial load on component mount
  useEffect(() => {
    getAccountTransactionListHandler(data, 1, false);
  }, []);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    // Reset for new search/filter
    setTransactionList([]);
    offsetRef.current = 1;
    hasMoreRef.current = true;
    totalLoadedRef.current = 0;
    getAccountTransactionListHandler(data, 1, false);
  }, [selectedRange, activeTab, filter.search]);

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
  };

  const getAccountTransactionListHandler = async (data, offset, isLoadMore = false) => {
    // Guard: Check refs synchronously
    if (isLoadingRef.current) {
      return;
    }

    if (isLoadMore && !hasMoreRef.current) {
      return;
    }

    if (!data) {
      console.error('No data provided:', data);
      return;
    }

    try {
      isLoadingRef.current = true;

      if (!isLoadMore && loadingBarRef.current) {
        loadingBarRef.current.continuousStart();
      }

      if (isLoadMore) {
        setLoadingMore(true);
      } else {
        setInitialLoading(true);
      }

      const res = await getAccountingTransaction({
        limit: filter.limit,
        offset: offset,
        search: filter.search,
        company_id: StorageService?.getCompanyId(),
        account_id: data?.account_id,
        start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        approval_status: activeTab,
      });

      if (res?.responseCode === 200) {
        const { list, ...resData } = res?.data;
        
        setAccountDetails(res?.data?.account_detail);
        setTotalItems(res?.data?.total_record);

        let newData = list || [];
        let totalRecord = res?.data?.total_record || 0;

        if (isLoadMore) {
          // Skip first item (duplicate default entry)
          const dataToAppend = newData.slice(1);

          setTransactionList((prev) => {
            const updatedList = [...(prev.list || []), ...dataToAppend];
            const actualCount = updatedList.length;

            // Update ref immediately
            hasMoreRef.current = actualCount < totalRecord;

            return {
              ...resData,
              list: updatedList
            };
          });

          totalLoadedRef.current = totalLoadedRef.current + dataToAppend.length;
        } else {
          // Handle filtering for activeTab == 2 on initial load
          let finalList = newData;
          if (activeTab == 2 && newData.length > 0) {
            finalList = newData.filter((_, index) => index !== 0);
          }

          setTransactionList({ ...resData, list: finalList });
          const actualCount = finalList.length;

          // Update ref immediately
          hasMoreRef.current = actualCount < totalRecord;
          totalLoadedRef.current = finalList.length;
        }

      } else {
        console.log('❌ API error, navigating back');
        navigate('/accounting/transactions');
      }
    } catch (error) {
      console.error('Exception in API call:', error);
      toast.error('Error');
    } finally {
      if (!isLoadMore && loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
      
      if (isLoadMore) {
        setLoadingMore(false);
      } else {
        setInitialLoading(false);
      }

      isLoadingRef.current = false;
    }
  };

  // Infinite scroll handler with proper dependencies
  const handleScroll = React.useCallback(() => {
    if (!tableContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = tableContainerRef.current;

    // Check if scrolled to bottom (with 50px threshold)
    if (scrollHeight - scrollTop <= clientHeight) {
      if (!isLoadingRef.current && hasMoreRef.current && data) {
        const nextOffset = offsetRef.current + 1;
        offsetRef.current = nextOffset;
        getAccountTransactionListHandler(data, nextOffset, true);
      }
    }
  }, [data, activeTab, selectedRange, filter.search]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, [handleScroll]);

  const tabProps = {
    tabList: constant.transactionsDetailsTabs,
    callBackTab: (e) => {
      setActiveTab(e);
    },
    activeTab: activeTab,
  };

  const getNumberSign = (number) => {
    const parsedNumber = parseFloat(number);
    if (isNaN(parsedNumber)) return 0;
    return parsedNumber < 0 ? `${number}` : number;
  };

  const handleDelteSubmit = (i) => {
    setConfirmModalShow(i);
  };

  const handleDelete = async () => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      transaction_id: confirmModalShow?._id || paymentVoucherOpen?._id
    }
    try {
      setDeleteLoading(true)
      const res = await deleteTransactionApi(payload)
      if (res?.responseCode == 200) {
        toast.success(res?.responseMessage)
        setConfirmModalShow(false);
        setPaymentVoucherOpen(false)
        setTransactionList([]);
        offsetRef.current = 1;
        hasMoreRef.current = true;
        totalLoadedRef.current = 0;
        getAccountTransactionListHandler(data, 1, false);
      } else {
        toast.error(res?.responseMessage)
      }
    } catch (error) {
      toast.error(error?.message)
    } finally {
      setDeleteLoading(false)
    }
  };

  let confirmModalProps = {
    show: confirmModalShow,
    closeModal: (e) => {
      setConfirmModalShow(false);
    },
    title: "Confirm",
    submitTitle: "Delete",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
    isLoadding: deleteLoading,
    disabled: deleteLoading
  };

  useEffect(() => {
    const isClear = setTimeout(() => {
      setFilter((s) => ({ ...s, search: isSearch }))
      offsetRef.current = 1;
    }, 500)

    return () => clearTimeout(isClear)
  }, [isSearch])

  const callbackPreview = (e, row) => {
    setPaymentVoucherOpen(row)
  }

  const paymentVoucherProps = {
    paymentVoucherOpen: paymentVoucherOpen,
    closeModal: () => setPaymentVoucherOpen(false),
    voucherId: paymentVoucherOpen?.voucher_id?._id,
    oprnDeleteModal: setConfirmModalShow
  }

  const transactionDownloadPdf = async () => {
    setPdfLoading(true)
    try {
      const payload = {
        search: isSearch,
        company_id: StorageService.getCompanyId(),
        account_id: data?.account_id,
        start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        approval_status: activeTab,
        is_web: true
      }
      const response = await fetch(`${AppConfig.api_baseurl}${API.TRANSACTIONS_REPORT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': `${isToken}`,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        if (errorBody?.responseMessage) {
          toast.error(errorBody?.responseMessage);
        }
        throw new Error(`Server Error (${errorBody?.responseMessage})`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${transactionList?.account_detail?.name}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error(error);
    } finally {
      setPdfLoading(false);
    }
  }

  const exportHandle = async () => {
    setExcelLoading(true);
    try {
      const payload = {
        search: isSearch,
        company_id: StorageService.getCompanyId(),
        account_id: data?.account_id,
        start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        approval_status: activeTab,
        is_web: true
      };
      const response = await fetch(
        `${AppConfig.api_baseurl}${API.ACCOUNT_EXPORT_EXCEL}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Token: `${isToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "account_transaction.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error(error);
      toast.error('Export failed');
    } finally {
      setExcelLoading(false);
    }
  };

  const callBack = () => {
    setOpenEditModal(false)
    offsetRef.current = 1;
    hasMoreRef.current = true;
    totalLoadedRef.current = 0;
    getAccountTransactionListHandler(data, 1, false);
  }

  let accountEditModalProps = {
    isOpen: openEditModal,
    closeModal: (e) => setOpenEditModal(false),
    modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
    footerPart: false,
    approvalBtn: true,
    approvalBtnTxt: 'Cancel',
    modalTitle: "Edit Account",
    submitTitle: "Save",
    accountDetails: accountDetails,
    callBack: callBack
  }

  return (
    <>
      <div className="_trnsBr_flex">
        <div className="_leftBrch_filts">
          <div className='branch_left' style={{ justifyContent: 'flex-start', marginBottom: '1px' }}>
            <h6>{transactionList?.account_detail?.name ? transactionList?.account_detail?.name : 'Loading...'}</h6>

            <button
              className="anime-btn _addComm_btn __editPetyCash"
              onClick={() => setOpenEditModal(true)}
              disabled={!transactionList?.account_detail?.name || initialLoading}
            >
              Edit
            </button>
          </div>
          <div className="_brchsBalance">
            <span
              className={`${transactionList?.available_balance >= 0 ? "_plus₹" : "_minus₹"
                }`}
            >
              {`Balance ₹ ${getNumberSign(
                transactionList?.available_balance
              )} `}{" "}
            </span>
            <span
              className={`${transactionList?.account_detail?.under_approval_balance >= 0
                ? "_plus₹"
                : "_minus₹"
                }`}
            >
              {`Under Approval ₹ ${getNumberSign(
                transactionList?.account_detail?.under_approval_balance
              )} `}{" "}
            </span>
          </div>
        </div>

        <div className="_rightBrch_filts">
          <div>
            <CommonInput
              label="Search"
              value={isSearch}
              type="text"
              placeholder="Search"
              name="search"
              onChange={(e) => setIsSearch(e.target.value)}
            />
          </div>
          <div>
            <CustomSelect
              placeholder="Category"
              label="Category"
              options={expenseList}
            />
          </div>
          <div>
            <CommonDateRange
              initialStartDate={selectedRange.startDate}
              initialEndDate={selectedRange.endDate}
              onApply={handleApply}
            />
          </div>
          <a href="" className="_addComm_btn _envlBtn">
            <FaEnvelope />
          </a>
          <button
            className="_addComm_btn"
            onClick={(e) => exportHandle(e)}
            disabled={excelLoading || !transactionList?.account_detail?.name}
          >
            {excelLoading ? 'Exporting...' : 'Export'}
          </button>
          <button
            className="_addComm_btn"
            onClick={(e) => transactionDownloadPdf(e)}
            disabled={pdfLoading || !transactionList?.account_detail?.name}
          >
            {pdfLoading ? 'Downloading...' : 'Download'}
          </button>
        </div>
      </div>

      <div className="addPr_flBx _altDetail">
        <Tab {...tabProps} />
        <div className="_transactionTable" ref={tableContainerRef} style={{ maxHeight: '600px', overflowY: 'auto' }}>
          {initialLoading && transactionList?.list?.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <span>Loading transactions...</span>
            </div>
          ) : (
            <CustomeTable
              columns={columns}
              data={accessorList(
                transactionList?.list?.length ? transactionList?.list : []
              )}
              callbackPreview={callbackPreview}
            />
          )}
          {loadingMore && (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <span>Loading more...</span>
            </div>
          )}
          {!hasMoreRef.current && transactionList?.list?.length > 0 && (
            <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
              <span>No more transactions</span>
            </div>
          )}
        </div>
      </div>

      {openEditModal && <EditAccountingModal {...accountEditModalProps} />}

      {confirmModalShow && (
        <ConfirmModalFor {...confirmModalProps}>
          <>
            <p className="_confirmPrx">
              {" "}
              Are you sure you want to delete " {"Transaction"} "{" "}
            </p>
          </>
        </ConfirmModalFor>
      )}

      {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
    </>
  );
};

export default TransactionsDetails;

const CustomeTable = ({ columns, data, callbackPreview }) => {
  return (
    <table className="">
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={index}>{column.header}</th>
          ))}
          <th></th>
        </tr>
      </thead>

      <tbody>
        {data?.map((row, rowIndex) => (
          <tr key={rowIndex} onClick={(e) => rowIndex != 0 && callbackPreview(e, row)} style={{ cursor: 'pointer' }}>
            {columns.map((column, colIndex) => (
              <td key={colIndex}>{row[column.accessor]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};